import React from 'react';
import { useTour } from '../../contexts/TourContext';
import LegacyVaultTour from './LegacyVaultTour';
import TelegramSetupTour from './TelegramSetupTour';
import SubscriptionTrackerTour from './SubscriptionTrackerTour';
import EmotionalSpendingTour from './EmotionalSpendingTour';
import BufferBudgetTour from './BufferBudgetTour';
import HabitTrackerTour from './HabitTrackerTour';
import InformalDebtTour from './InformalDebtTour';
import GoalPrioritizationMatrixTour from './GoalPrioritizationMatrixTour';
import BudgetManagerTour from './BudgetManagerTour';

const GlobalTour: React.FC = () => {
    const { isRunning, currentTour } = useTour();

    if (!isRunning || !currentTour) {
        return null;
    }

    switch (currentTour) {
        case 'telegram-notifications':
            return <TelegramSetupTour isRunning={isRunning} onComplete={() => { }} />;
        case 'legacy-vault':
            return <LegacyVaultTour isRunning={isRunning} onComplete={() => { }} />;
        case 'subscription-tracker':
            return <SubscriptionTrackerTour isRunning={isRunning} onComplete={() => { }} />;
        case 'emotional-spending':
            return <EmotionalSpendingTour isRunning={isRunning} onComplete={() => { }} />;
        case 'buffer-budget':
            return <BufferBudgetTour isRunning={isRunning} onComplete={() => { }} />;
        case 'habit-tracker':
            return <HabitTrackerTour isRunning={isRunning} onComplete={() => { }} />;
        case 'informal-debt':
            return <InformalDebtTour isRunning={isRunning} onComplete={() => { }} />;
        case 'goal-prioritization-matrix':
            return <GoalPrioritizationMatrixTour isRunning={isRunning} onComplete={() => { }} />;
        case 'budget-manager':
            return <BudgetManagerTour isRunning={isRunning} onComplete={() => { }} />;
        default:
            return null;
    }
};

export default GlobalTour;
